// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-calendar-close {
    display: flex;
    justify-content: end;
    gap: 5px;
    padding-bottom: 10px;
    cursor: pointer;
    color: rgb(0, 44, 93);
  }
  
  .custom-calendar-close-icon {
    font-size: 35px !important;
  }
  
  .custom-calendar-close-text {
    align-self: center;
    font-family: "Inter";
  }
  
  .custom-calendar * {
    font-family: "Inter";
  }
  
  .custom-calendar {
    font-family: "Inter";
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  
  .custom-calendar-header-attendance {
    font-size: 20px;
    font-weight: 500;
  }
  
  /* Calendar Navbar */
  .cal-view-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    background-color: #f4f4f4;
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
    margin-bottom: 10px;
  }
  
  .cal-view-nav-left {
    display: flex;
    align-items: center;
  }
  
  .cal-view-nav-back-arrow,
  .cal-view-nav-forward-arrow {
    cursor: pointer;
    font-size: 24px;
    color: #333;
    margin: 0 10px;
  }
  
  .cal-view-nav-back-arrow:hover,
  .cal-view-nav-forward-arrow:hover {
    color: #017A39;
  }
  
  .cal-view-nav-today-attendance-btn {
    padding: 5px 15px;
    font-size: 14px;
    background-color: #555;
    color: #fff;
    border: none;
    border-radius: 20px;
    cursor: pointer;
  }
  
  .cal-view-nav-today-attendance-btn:hover {
    background-color: #333;
  }
  
  .cal-view-nav-center {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }
  
  .cal-view-nav-right {
    display: flex;
    align-items: center;
  }
  
  .cal-view-nav-right-content {
    padding: 5px 10px;
    cursor: pointer;
    font-size: 14px;
    color: #333;
    margin: 0 5px;
  }
  
  .cal-view-nav-right-content:hover {
    background-color: #017A39;
    color: #fff;
    border-radius: 5px;
  }
  
  .cal-view-nav-right-content-active {
    background-color: #017A39;
    color: #fff;
    border-radius: 5px;
    font-weight: bold;
  }
  
  
  .custom-calendar .rbc-month-row {
    overflow: visible; /* Hide overflow */
    min-height: 115px;
  }
  
  .custom-calendar .rbc-month-view {
    border-radius: 5px;
  }
  
  .custom-calendar .rbc-header {
    padding: 5px;
  }
  
  /* Indicators */
  .indicator-div {
    display: flex;
    gap: 10px;
    align-items: center;
    padding: 10px 10px 10px 0px;
  }
  
  .indicator-color {
    width: 40px;
    height: 25px;
    border-radius: 5px;
  }
  
  .indicator-name {
    font-size: 16px;
  }

  .custom-calendar .rbc-month-view .rbc-day-bg.rbc-off-range-bg {
    background-color: transparent !important;
  }
  
  /* Set gray background for off-range weekends */
  .custom-calendar .rbc-month-view .rbc-day-bg.rbc-off-range-bg:nth-child(7),
  .custom-calendar .rbc-month-view .rbc-day-bg.rbc-off-range-bg:nth-child(6) {
    background-color: #f0f0f0 !important; /* or any gray */
  }

  .employee-dropdown {
    padding: 8px 12px;
    font-size: 14px;
    margin-left: 10px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    color: #333;
    cursor: pointer;
    outline: none;
    transition: all 0.2s ease;
  }
  
  .employee-dropdown:hover {
    border-color: #888;
  }
  
  .employee-dropdown:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);
  }
  
  .employee-dropdown option {
    padding: 10px;
  }

  /* Remove hand cursor (pointer) from events */
.custom-calendar .rbc-event {
  cursor: default !important;
}

/* Remove pointer from date cells (numbers at the top of each day box) */
.custom-calendar .rbc-date-cell {
  cursor: default !important;
}

/* Remove pointer from day backgrounds */
.custom-calendar .rbc-day-bg {
  cursor: default !important;
}

/* Make month rows taller to fit more events */
.rbc-month-row {
  min-height: 180px !important;
}

/* Ensure each event is spaced well */
.rbc-event {
  margin-bottom: 4px;
  min-height: 20px;
  padding: 2px 6px;
  font-size: 12px;
}

/* Prevent event content overflow */
.rbc-event-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}


.attendanceDescription{
  white-space: nowrap !important;
  word-wrap: break-word !important;
   text-overflow: ellipsis !important;
   overflow: hidden !important;
   width:150px !important
  
}

  `, "",{"version":3,"sources":["webpack://./src/views/panel/Attendance/Attendance.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,oBAAoB;IACpB,QAAQ;IACR,oBAAoB;IACpB,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;IAC3C,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;EAChB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,WAAW;IACX,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;;EAGA;IACE,iBAAiB,EAAE,kBAAkB;IACrC,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA,eAAe;EACf;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wCAAwC;EAC1C;;EAEA,+CAA+C;EAC/C;;IAEE,oCAAoC,EAAE,gBAAgB;EACxD;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,aAAa;IACb,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;EACf;;EAEA,6CAA6C;AAC/C;EACE,0BAA0B;AAC5B;;AAEA,wEAAwE;AACxE;EACE,0BAA0B;AAC5B;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,4BAA4B;AAC9B;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,8BAA8B;EAC9B,gCAAgC;GAC/B,kCAAkC;GAClC,2BAA2B;GAC3B;;AAEH","sourcesContent":[".custom-calendar-close {\n    display: flex;\n    justify-content: end;\n    gap: 5px;\n    padding-bottom: 10px;\n    cursor: pointer;\n    color: rgb(0, 44, 93);\n  }\n  \n  .custom-calendar-close-icon {\n    font-size: 35px !important;\n  }\n  \n  .custom-calendar-close-text {\n    align-self: center;\n    font-family: \"Inter\";\n  }\n  \n  .custom-calendar * {\n    font-family: \"Inter\";\n  }\n  \n  .custom-calendar {\n    font-family: \"Inter\";\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n  }\n  \n  .custom-calendar-header-attendance {\n    font-size: 20px;\n    font-weight: 500;\n  }\n  \n  /* Calendar Navbar */\n  .cal-view-nav {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px;\n    background-color: #f4f4f4;\n    border-radius: 8px;\n    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;\n    margin-bottom: 10px;\n  }\n  \n  .cal-view-nav-left {\n    display: flex;\n    align-items: center;\n  }\n  \n  .cal-view-nav-back-arrow,\n  .cal-view-nav-forward-arrow {\n    cursor: pointer;\n    font-size: 24px;\n    color: #333;\n    margin: 0 10px;\n  }\n  \n  .cal-view-nav-back-arrow:hover,\n  .cal-view-nav-forward-arrow:hover {\n    color: #017A39;\n  }\n  \n  .cal-view-nav-today-attendance-btn {\n    padding: 5px 15px;\n    font-size: 14px;\n    background-color: #555;\n    color: #fff;\n    border: none;\n    border-radius: 20px;\n    cursor: pointer;\n  }\n  \n  .cal-view-nav-today-attendance-btn:hover {\n    background-color: #333;\n  }\n  \n  .cal-view-nav-center {\n    font-size: 16px;\n    font-weight: bold;\n    color: #333;\n    text-align: center;\n  }\n  \n  .cal-view-nav-right {\n    display: flex;\n    align-items: center;\n  }\n  \n  .cal-view-nav-right-content {\n    padding: 5px 10px;\n    cursor: pointer;\n    font-size: 14px;\n    color: #333;\n    margin: 0 5px;\n  }\n  \n  .cal-view-nav-right-content:hover {\n    background-color: #017A39;\n    color: #fff;\n    border-radius: 5px;\n  }\n  \n  .cal-view-nav-right-content-active {\n    background-color: #017A39;\n    color: #fff;\n    border-radius: 5px;\n    font-weight: bold;\n  }\n  \n  \n  .custom-calendar .rbc-month-row {\n    overflow: visible; /* Hide overflow */\n    min-height: 115px;\n  }\n  \n  .custom-calendar .rbc-month-view {\n    border-radius: 5px;\n  }\n  \n  .custom-calendar .rbc-header {\n    padding: 5px;\n  }\n  \n  /* Indicators */\n  .indicator-div {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    padding: 10px 10px 10px 0px;\n  }\n  \n  .indicator-color {\n    width: 40px;\n    height: 25px;\n    border-radius: 5px;\n  }\n  \n  .indicator-name {\n    font-size: 16px;\n  }\n\n  .custom-calendar .rbc-month-view .rbc-day-bg.rbc-off-range-bg {\n    background-color: transparent !important;\n  }\n  \n  /* Set gray background for off-range weekends */\n  .custom-calendar .rbc-month-view .rbc-day-bg.rbc-off-range-bg:nth-child(7),\n  .custom-calendar .rbc-month-view .rbc-day-bg.rbc-off-range-bg:nth-child(6) {\n    background-color: #f0f0f0 !important; /* or any gray */\n  }\n\n  .employee-dropdown {\n    padding: 8px 12px;\n    font-size: 14px;\n    margin-left: 10px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    background-color: #fff;\n    color: #333;\n    cursor: pointer;\n    outline: none;\n    transition: all 0.2s ease;\n  }\n  \n  .employee-dropdown:hover {\n    border-color: #888;\n  }\n  \n  .employee-dropdown:focus {\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.2);\n  }\n  \n  .employee-dropdown option {\n    padding: 10px;\n  }\n\n  /* Remove hand cursor (pointer) from events */\n.custom-calendar .rbc-event {\n  cursor: default !important;\n}\n\n/* Remove pointer from date cells (numbers at the top of each day box) */\n.custom-calendar .rbc-date-cell {\n  cursor: default !important;\n}\n\n/* Remove pointer from day backgrounds */\n.custom-calendar .rbc-day-bg {\n  cursor: default !important;\n}\n\n/* Make month rows taller to fit more events */\n.rbc-month-row {\n  min-height: 180px !important;\n}\n\n/* Ensure each event is spaced well */\n.rbc-event {\n  margin-bottom: 4px;\n  min-height: 20px;\n  padding: 2px 6px;\n  font-size: 12px;\n}\n\n/* Prevent event content overflow */\n.rbc-event-content {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n\n.attendanceDescription{\n  white-space: nowrap !important;\n  word-wrap: break-word !important;\n   text-overflow: ellipsis !important;\n   overflow: hidden !important;\n   width:150px !important\n  \n}\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
